import { IonButton, IonContent, IonPage, useIonRouter } from '@ionic/react'
import { useForm } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import { zodResolver } from '@hookform/resolvers/zod'

import { CheckInButton } from '../../../../components/ui/buttons/check-in-button'
import { StyledError } from '../../../../components/ui/form/errors'
import { TextInput } from '../../../../components/ui/form/input'
import { emailCheckInSchema } from '../../../../check-in/check-in.schema'
import { CheckInWrapper } from '../../../../check-in/components/check-in-wrapper'
import { useEmailCheckIn } from '../../../../check-in/utils'
import { RotateInfoIntro } from '../../../../rotate/components/rotate-info-intro'

import type { EmailCheckIn } from '../../../../check-in/check-in.schema'

function EmailCheckInPage() {
  return (
    <IonPage>
      <IonContent>
        <EmailCheckInContent />
      </IonContent>
    </IonPage>
  )
}

function EmailCheckInContent() {
  const router = useIonRouter()

  const { handleCheckIn, isLoading } = useEmailCheckIn({
    addCustomerRedirect: '/check-in/paired/admin/add-customer',
    loyaltyRedirect: `/check-in/paired/admin/redeem-loyalty`,
  })

  function handleCancel() {
    router.canGoBack()
      ? router.goBack()
      : router.push('/check-in/paired/admin/home', 'back', 'pop')
  }

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<EmailCheckIn>({
    defaultValues: { email: '' },
    resolver: zodResolver(emailCheckInSchema),
  })

  return (
    <CheckInWrapper>
      <div className="flex flex-col items-center gap-y-3">
        <div className="flex items-center gap-x-3">
          <IonButton
            color="secondary"
            disabled={isLoading}
            onClick={handleCancel}
          >
            Cancel
          </IonButton>
          <IonButton
            disabled={isLoading}
            fill="solid"
            onClick={() =>
              router.push(
                `/check-in/paired/admin/phone-check-in`,
                'none',
                'pop'
              )
            }
          >
            Check-In With Phone
          </IonButton>
        </div>

        <div className="bg-ion-color-secondary w-full max-w-96 rounded-2xl p-2">
          <form
            onSubmit={handleSubmit(handleCheckIn)}
            className="w-full space-y-4"
          >
            <TextInput
              control={control}
              name="email"
              disabled={isLoading}
              placeholder="Enter Your Email"
            />
            <ErrorMessage as={StyledError} name="email" errors={errors} />
            <div className="text-center">
              <CheckInButton
                disabled={isLoading}
                label="Check In"
                type="submit"
              />
            </div>
          </form>
        </div>

        <div className="space-y-3 self-center text-center">
          <RotateInfoIntro>Enter email to check in customer.</RotateInfoIntro>
        </div>
      </div>
    </CheckInWrapper>
  )
}

export { EmailCheckInPage }
